//------------------------------------------------------
//		中・大ページに必要なjsをまとめて読み込む
//------------------------------------------------------
global.$ = global.jQuery = require('jquery');
 
//--------------------------------
//		LazyLoad
//--------------------------------
import "./js/jquery.lazy.js"

//--------------------------------
//		ヘッダや基本ルーチン
//--------------------------------
import "./js/tirakita_base_functions.js";

//--------------------------------
//		フローティングカート
//--------------------------------
import "./js/floating_cart.js";

//--------------------------------
//		中・大ページ用のルーチン
//--------------------------------
import "./js/tirakita_mb_functions.js";

//--------------------------------
//		AjaxSuggest2
//--------------------------------
import "./js/jquery.ajaxSuggest2.js";

//--------------------------------
//		DIVを整頓するmasonry
//--------------------------------
import "./js/masonry.pkgd.js";

//--------------------------------
//		CART POP UP
//--------------------------------
//import "../../sys/popup/cart_popup.js"

//--------------------------------
//		縮小するパンくずリスト
//--------------------------------
import "./js/jquery.rcrumbs.min.js";

//--------------------------------
//		ハートの吹き出し部分
//--------------------------------
import "./js/heart_explanation.js";

//--------------------------------
//		検索用
//--------------------------------
import "./js/db_get.js";

//--------------------------------
//		クーポンIDをクリップボードにコピー
//--------------------------------
import "./js/autogenerate_coupon_id_copy.js"
